<script>
import AvatarComponent from '../__components/Avatar.vue';
import MixinItem from '../__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    AvatarComponent,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  mounted() {
    this.$emit('fixed-label', true);
    this.$emit('show-border', false);
  },
};
</script>
<template>
  <AvatarComponent
    :type="type"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @submit="$emit('submit', $event)"
  />
</template>
